// extracted by mini-css-extract-plugin
export default {"topDecks":"TopDecks_topDecks__1lhy8","deck":"TopDecks_deck__jCuyC","stats":"TopDecks_stats__elLO0","link":"TopDecks_link__2lmjO"};